import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ProjectService from '../services/ProjectService';
import IBaseState from '../../types/IBaseState';
import IProject from '../../types/IProject';
import { LOGOUT } from '../../constants/actions/auth.constants';

const NAME = 'PARTICIPANT_PROJECT';

const getProjects = createAsyncThunk(
    `${NAME}/getProjects`,
    ProjectService.getProjects,
);

const getProject = createAsyncThunk(
    `${NAME}/getProject`,
    ProjectService.getProject,
);

const giveConsent = createAsyncThunk(
    `${NAME}/giveConsent`,
    ProjectService.giveConsent,
);

type State = {
    project: IBaseState<IProject | undefined>;
    projects: IBaseState<IProject[]>;
    consent: IBaseState<any>;
};

const initialState: State = {
    project: {
        data: undefined,
        loading: false,
    },
    projects: {
        data: [],
        loading: false,
    },
    consent: {
        data: undefined,
        loading: false,
    },
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProjects.pending, (state) => {
            state.projects.loading = true;
        });
        builder.addCase(getProjects.fulfilled, (state, action) => {
            state.projects.loading = false;
            state.projects.data = action.payload.data as IProject[];
        });
        builder.addCase(getProjects.rejected, (state) => {
            state.projects.loading = false;
        });

        builder.addCase(getProject.pending, (state) => {
            state.project.loading = true;
        });
        builder.addCase(getProject.fulfilled, (state, action) => {
            state.project.loading = false;
            state.project.data = action.payload.data as IProject;
        });
        builder.addCase(getProject.rejected, (state) => {
            state.project.loading = false;
        });

        builder.addCase(giveConsent.pending, (state) => {
            state.consent.loading = true;
            state.consent.success = false;
        });
        builder.addCase(giveConsent.fulfilled, (state, action) => {
            state.consent.loading = false;
            state.consent.success = true;
            const id = action.meta.arg;
            const index = state.projects.data?.findIndex(
                (project) => project.id === id,
            );
            if (index >= 0) {
                state.projects.data[index].consent = true;
            }
        });
        builder.addCase(giveConsent.rejected, (state) => {
            state.consent.loading = false;
            state.consent.success = false;
        });
        builder.addCase(LOGOUT, () => initialState);
    },
});

const ProjectActions = {
    getProjects,
    getProject,
    giveConsent,
};

export default ProjectActions;
export const ProjectReducer = slice.reducer;
